import { Toast } from "vant";

export class VLoading {
  start(message = "加载中...", opt = {}) {
    Toast.loading({ duration: 0, message, forbidClick: true, loadingType: "spinner", ...opt });
  }
  stop() {
    Toast.clear();
  }
}

export const vLoading = new VLoading();
